import cx from 'classnames'
import { Group, type GroupProps } from 'react-aria-components'

import { rawTextInputStyles } from '../../textInput/rawTextInputStyles'

type Props = Pick<
  GroupProps,
  'children' | 'onBlurCapture' | 'onKeyDownCapture' | 'onPointerDownCapture'
> & {
  isInError: boolean
  isDisabled: boolean
  hasClearButton?: boolean
}

export const DateGroup = ({
  isDisabled,
  isInError,
  hasClearButton = false,
  ...groupProps
}: Props) => (
  <Group
    {...groupProps}
    className={cx(
      'relative flex gap-0.5',
      hasClearButton ? 'pe-12' : 'pe-8', // ensure space for the clear button and calendar icon
      rawTextInputStyles({
        isInError,
        disabled: isDisabled,
        focusRingVariant: 'focusWithin',
      }),
    )}
  />
)
